import { supabase } from "@/lib/supabase";

export const BRANDS_PAGE_SIZE = 20;

/** brands feeds the Add Domain form, jetsik_brands the dashboard filter. */
export type BrandSource = "brands" | "jetsik_brands";

export interface BrandOption {
  name: string;
}

export interface FetchBrandsPageParams {
  search: string;
  page: number;
  pageSize?: number;
  source?: BrandSource;
}

class BrandService {
  private static instance: BrandService;

  private constructor() {}

  public static getInstance(): BrandService {
    if (!BrandService.instance) {
      BrandService.instance = new BrandService();
    }
    return BrandService.instance;
  }

  public async getBrandsPage({
    search,
    page,
    pageSize = BRANDS_PAGE_SIZE,
    source = "brands",
  }: FetchBrandsPageParams): Promise<BrandOption[]> {
    const from = page * pageSize;
    const to = from + pageSize - 1;

    // Both relations are a single name column; the typed client just cannot
    // take a union of relation names.
    let query = supabase
      .from(source as "brands")
      .select("name")
      .order("name")
      .range(from, to);

    if (search) {
      query = query.ilike("name", `%${search}%`);
    }

    const { data, error } = await query;
    if (error) throw error;
    return data ?? [];
  }
}

export const brandService = BrandService.getInstance();
